export const environment = {
    "production": false,
    "ionicEnvName": "dev",
    "domain": "dvep.net",
    "customerSupportEmailAddress": "core@devere-group.com",
    "trackUsage": true,
    "logServerErrors": false,
    "intercom": {
        "appId": "yorkgms9",
        "apiKeyiOS": "ios_sdk-d1fe5b7b70f4e03311c3130347355a011e301303",
        "apiKeyAndroid": "android_sdk-a0275cd8cad523182a39bdd2db27b0c625f19216"
    },
    "appVersion": "2.7.6",
    "firebaseConfig": {
        "apiKey": "AIzaSyBCzSVTZHfsA9qxpssB3Z8Tos7JTyRoh94",
        "authDomain": "devere-core-app-test.firebaseapp.com",
        "databaseURL": "https://devere-core-app-test.firebaseio.com",
        "projectId": "devere-core-app-test",
        "storageBucket": "devere-core-app-test.appspot.com",
        "messagingSenderId": "222047028331",
        "appId": "1:222047028331:web:a8d50286dc00dd1a25dd2e",
        "measurementId": "G-LX11W4NSFK"
    }
};